import * as React from 'react';
import RecipientNav from './nav';
import WaitlistUploadForm from './waitlist/waitlist-upload-form';
import { ContentWrapper } from './styles';

interface IProps {
    subSection: string,
    centerId: number,
    centerAlias: string
}

interface IState {
}

class Recipient extends React.Component<IProps, IState> {
    readonly state: IState = {

    }

    componentWillMount = () => { }

    componentDidMount = () => { }

    handleTabSelect = (key: string) => { }

    render = () => {
        var subSection = this.props.subSection;
        var centerId = this.props.centerId;
        var centerAlias = this.props.centerAlias;

        return (
            <div style={{ padding: 10 }}>
                <RecipientNav
                    activeKey={subSection}
                    centerId={centerId}
                    centerAlias={centerAlias}
                    onTabSelect={this.handleTabSelect}
                />
                <ContentWrapper>
                    <WaitlistUploadForm centerId={ centerId } />
                </ContentWrapper>
            </div>
        )
    }

}

export default Recipient